import { styled, Box } from '@mui/material';

export const DatePickerStyled = styled(Box)(() => ({
  position: 'relative',
}));
